import { Component, input, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { SearchableFieldComponent } from '../../../../../../../shared/components/searchable-field/searchable-field.component';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../../../../shared/tokens/searchable-strategy.token';
import { VehicleMakeSearchStrategy } from '../../../../config/vehicle-makes-searchable-strategy';

@Component({
	selector: 'app-make-searchable',
	template: `
		<app-searchable-field
			[label]="label()"
			[formControl]="searchableId"></app-searchable-field>
	`,
	imports: [ReactiveFormsModule, SearchableFieldComponent],
	host: {
		class: 'w-full',
	},
	providers: [
		{
			provide: SEARCHABLE_STRATEGY_TOKEN,
			useClass: VehicleMakeSearchStrategy,
		},
	],
})
export class MakeSaerchableComponent {
	@Input() searchableId: FormControl;
	label = input<string>();
}
